import React from 'react';
import { CheckIcon } from 'lucide-react';
import { coverage, systemNumbers } from '../data/content';
import { Reveal } from './Reveal';
const TRAINING_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/1e24e936-b109-4636-bd1e-b1481dc35cd8.jpg';
export function SystemIntro() {
  return <section className="bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="sistema" data-id="element-233" data-mp="28884ulg68wds">
      <div className="mx-auto max-w-6xl" data-id="element-234" data-mp="1bi7jyxixb01r">
        <Reveal data-id="element-235" data-mp="1bjab96k5r4i7">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-236" data-mp="1bjshmw0jaz3u">
            El sistema más completo para profes de fútbol
          </p>
          <h2 id="sistema" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-237" data-mp="1khm99tnct4ko">
            Megapack Entrenador 360°
          </h2>
          <p className="mt-6 max-w-readable text-lg leading-relaxed text-ink-soft" data-id="element-238" data-mp="2vwhnxfm03618">
            Más de 240 páginas con prácticas completas, ejercicios con diagramas,
            manejo de grupo y planillas de evaluación. Todo ya preparado para que
            solo tengas que abrirlo y entrenar.
          </p>
        </Reveal>

        <div className="mt-14 grid items-start gap-12 lg:grid-cols-[1fr_0.85fr] lg:gap-16" data-id="element-239" data-mp="11htrshppm0dr">
          <div data-id="element-240" data-mp="wge7irvcvxwf">
            <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-paper-line bg-paper-line" data-id="element-241" data-mp="wk209osz8ga3">
              {systemNumbers.map(item => <div key={item.label} className="bg-paper p-6" data-id="element-242" data-mp="mkkyhiguimje">
                  <dt className="text-sm text-ink-dim" data-id="element-243" data-mp="htb6wcbql94v">{item.label}</dt>
                  <dd className="display mt-2 text-4xl text-ink sm:text-5xl" data-id="element-244" data-mp="hr89h7898dq4">
                    {item.value}
                  </dd>
                </div>)}
            </dl>

            <div className="mt-10" data-id="element-245" data-mp="8qa3ije99w4w">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-246" data-mp="3t0ev5yoxoi4">
                Cobertura total
              </p>
              <h3 className="display mt-3 text-2xl text-ink sm:text-3xl" data-id="element-247" data-mp="3v04lw0uu5aqj">
                Del baby fútbol al fútbol 11
              </h3>
              <ol className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-248" data-mp="3qb28p6k7pre5">
                {coverage.map((item, i) => <li key={item} className="flex items-start gap-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-249" data-mp="3cbkegbo5dlxe" data-mpi={i}>
                    <span className="display mt-0.5 shrink-0 text-sm text-grass" data-id="element-250" data-mp="3geyw16rqiacy">
                      0{i + 1}
                    </span>
                    {item}
                  </li>)}
              </ol>
            </div>
          </div>

          <Reveal delay={0.06} data-id="element-251" data-mp="3v93rrrhn1qpm">
            <figure data-id="element-252" data-mp="3v82dle5bso3o">
              <img src={TRAINING_IMAGE} alt="Entrenamiento organizado: chicos trabajando en un circuito mientras el profe dirige" className="w-full rounded-xl object-cover shadow-xl" data-id="element-253" data-mp="36claxzk98y2" />
              <figcaption className="mt-4 flex items-start gap-2 text-sm text-ink-dim" data-id="element-254" data-mp="vngko7a4tkpz">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-255" data-mp="2gc0rnwyycg6o" />
                Pensado para el barro de la Argentina: 20 pibes, cuatro conos y una
                hora de cancha.
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>;
}